import { InputfieldTypes } from "../../../enums/InputFieldAttributesEnums";

export const ticketFilterConstants = {
  HEADER_TXT: "Filter",
  SUBMIT_BTN_TXT: "Apply",
  CANCEL_BTN_TXT: "Cancel",
  CLEAR_BTN_TXT: "Clear Filters",
  DRAWER_PLACEMENT: "right",
  DRAWER_SIZE: "large",
  DRAWER_WIDTH: "30%",
  DRAWER_HEIGHT: "100vh",
  CANCEL_BTN_CLASS: "cancelFilterButton",
  SELECT_PLACEHOLDER: "Select",
};

export const filterFieldConstants = {
  CUSTOMER_FILTER_LABEL: "Customer Name",
  TRUCK_FILTER_LABEL: "Truck #",
  JOB_NAME_FILTER_LABEL: "Job Name",
  CUSTOMER_FILTER_NAME: "customerNameFilter",
  TRUCK_FILTER_NAME: "truckNumberFilter",
  JOB_NAME_FILTER_NAME: "jobNameFilter",
  CUSTOMER_FILTER_PLACEHOLDER: "Select",
  TRUCK_FILTER_PLACEHOLDER: "Select",
  JOB_NAME_FILTER_PLACEHOLDER: "Select",
};

export const filterFormMap = [
  {
    key: "customerName",
    field: filterFieldConstants.CUSTOMER_FILTER_NAME,
  },
  {
    key: "truckNumber",
    field: filterFieldConstants.TRUCK_FILTER_NAME,
  },
  {
    key: "jobName",
    field: filterFieldConstants.JOB_NAME_FILTER_NAME,
  },
];

export const filterHeaderStyle = {
  backgroundColor: "#586370",
  padding: "1rem",
  color: "white",
};

export const FilterOptionFields = [
  {
    type: InputfieldTypes.SELECT,
    name: filterFieldConstants.CUSTOMER_FILTER_NAME,
    label: filterFieldConstants.CUSTOMER_FILTER_LABEL,
    placeholder: filterFieldConstants.CUSTOMER_FILTER_PLACEHOLDER,
    showSearch: true,
    allowClear: true,
    optionFilterProp: "label",
  },
  {
    type: InputfieldTypes.SELECT,
    name: filterFieldConstants.JOB_NAME_FILTER_NAME,
    label: filterFieldConstants.JOB_NAME_FILTER_LABEL,
    placeholder: filterFieldConstants.JOB_NAME_FILTER_PLACEHOLDER,
    showSearch: true,
    allowClear: true,
    optionFilterProp: "label",
  },
  {
    type: InputfieldTypes.SELECT,
    name: filterFieldConstants.TRUCK_FILTER_NAME,
    label: filterFieldConstants.TRUCK_FILTER_LABEL,
    placeholder: filterFieldConstants.TRUCK_FILTER_PLACEHOLDER,
    showSearch: true,
    allowClear: true,
    optionFilterProp: "label",
  },
];
